.text {
  font-family: var(--font-family);
  margin: 0;
}

/* size — pairs font-size with matching line-height */
.size-xs  { font-size: var(--text-size-xs);  line-height: var(--text-lh-xs); }
.size-s   { font-size: var(--text-size-s);   line-height: var(--text-lh-s); }
.size-m   { font-size: var(--text-size-m);   line-height: var(--text-lh-m); }
.size-l   { font-size: var(--text-size-l);   line-height: var(--text-lh-l); }
.size-xl  { font-size: var(--text-size-xl);  line-height: var(--text-lh-xl); }
.size-xxl { font-size: var(--text-size-xxl); line-height: var(--text-lh-xxl); }

/* weight */
.weight-regular  { font-weight: var(--text-weight-regular); }
.weight-medium   { font-weight: var(--text-weight-medium); }
.weight-semibold { font-weight: var(--text-weight-semibold); }

/* tone — matches the --text-* Figma alias tokens */
.tone-primary    { color: var(--text-primary); }
.tone-secondary  { color: var(--text-secondary); }
.tone-tertiary   { color: var(--text-tertiary); }
.tone-link       { color: var(--text-link); }
.tone-negative   { color: var(--text-negative); }
.tone-success    { color: var(--text-success); }
.tone-on-dark    { color: var(--text-on-dark); }

/* truncate — single-line ellipsis.
 *
 * `overflow: hidden` has no effect on inline boxes per CSS spec, so we
 * set `display: inline-block` to guarantee truncation works on the
 * default <span> render. If the consumer passes `as="div"` or wraps
 * Text in a flex/grid container (both blockify inline children), the
 * extra `display: inline-block` is harmless — it just narrows the box
 * to its content width, which is still the right behaviour for a
 * single-line ellipsis.
 *
 * Caller is still responsible for bounding the container width
 * (max-width, flex constraints, etc.) — truncation only kicks in
 * when the text overflows a constrained parent. */
.truncate {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  vertical-align: bottom;
}
